var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.isLoggedIn)?_c('header-tpl'):_vm._e(),_c('router-view',{attrs:{"isLoggedin":_vm.isLoggedIn}}),(_vm.isLoggedIn)?_c('footer-tpl'):_vm._e(),_c('transient-notification')],1)}
var staticRenderFns = []

export { render, staticRenderFns }